import { FF, FieldSet, MultiSelect, Validators } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { useTemplateManageContext } from '~bank-document-templates/manage/context'

export const Relationship = () => {
  const { formApi, data } = useTemplateManageContext()
  const { businessTypeOptions, entityTypeOptions } = data

  return (
    <FieldSet legend="Relationship">
      <FormRow>
        <Col>
          <formApi.Field
            name="businessTypes"
            validators={{
              onChange: ({ value, fieldApi }) => {
                const level = fieldApi.form.getFieldValue('level')
                if (level === 'company' || level === 'license') {
                  return Validators.required.field(value)
                }
                return undefined
              }
            }}
            children={(field) => (
              <FF
                required={
                  field.form.getFieldValue('level') === 'company' || field.form.getFieldValue('level') === 'license'
                }
                field={field}
                label="Business Type"
                input={(p) => (
                  <MultiSelect
                    {...p}
                    data={businessTypeOptions}
                    data-qa="Business Type"
                    hint="Select the relevant business type(s) from the list"
                  />
                )}
              />
            )}
          />
        </Col>
        <Col>
          <formApi.Field
            name="entityTypes"
            validators={{
              onChange: ({ value, fieldApi }) => {
                const level = fieldApi.form.getFieldValue('level')
                if (level === 'company' || level === 'license') {
                  return Validators.required.field(value)
                }
                return undefined
              }
            }}
            children={(field) => (
              <FF
                required={
                  field.form.getFieldValue('level') === 'company' || field.form.getFieldValue('level') === 'license'
                }
                field={field}
                label="Entity Type"
                input={(p) => (
                  <MultiSelect
                    {...p}
                    data={entityTypeOptions}
                    data-qa="Entity Type"
                    hint="Select one or more entity types that apply"
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
    </FieldSet>
  )
}
